export const styles = {
  formBox: {
    mt: 3,
    display: "flex",
    flexDirection: "column",
    gap: "3vh",
  },
  textFieldsBox: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  forgotPasswordBtn: {
    fontSize: 12,
    fontWeight: "bold",
  },
};
